import { t } from 'ttag'
import { useMemo } from 'react'

import { SLB } from '@h2/components/colors'
import { Heading } from '@h2/components/typography/heading'
import { Text } from '@h2/components/typography/text'
import { Option, OptionGroup } from '@h2/components/containers/optionGroup'
import { WorkforceIcon } from '@h2/components/icons/workforce'
import { LibrarianIcon } from '@h2/components/icons/librarian'
import { Card } from '@h2/common/components/card'

import { props } from './props'
import { ContentWrap, OptionBody } from './components'

import { Navigator } from '../highlights/navigator'
import { Back } from '../back'
import { Controls } from '../controls'

const CounselorType = ({ inDialog, properties, validate, renderPanel }) => {
  const counselorType = useMemo(() => properties.counselorType, [
    properties.counselorType
  ])

  return (
    <Card inDialog={inDialog}>
      <Card.Highlight color={SLB}>
        <Navigator type="counselor" />
      </Card.Highlight>
      <Card.Content>
        <ContentWrap>
          <Heading level="2" align="center" mb="12px">
            {t`Counselor Type`}
          </Heading>
          <Text align="center">{t`Select the option that most closely reflects your current role:`}</Text>
          <OptionGroup
            gap="15px"
            value={counselorType}
            onClick={value => validate({ counselorType: value })}>
            <Option value="librarian">
              <OptionBody>
                <LibrarianIcon size="large" />
                <span className="flex">
                  <span>{t`Librarian`}</span>
                  <span>{t`I coach, advise, direct and provide a valuable resource to patrons looking for help.`}</span>
                </span>
              </OptionBody>
            </Option>
            <Option value="workforce">
              <OptionBody>
                <WorkforceIcon size="large" />
                <span className="flex">
                  <span>{t`Workforce Development`}</span>
                  <span>{t`I'm helping build tomorrow's workforce.`}</span>
                </span>
              </OptionBody>
            </Option>
          </OptionGroup>
          <Controls>
            <Back onClick={() => renderPanel('navigatorType')} />
          </Controls>
        </ContentWrap>
      </Card.Content>
      <Card.Detour>
        <Back onClick={() => renderPanel('navigatorType')} />
      </Card.Detour>
    </Card>
  )
}

CounselorType.propTypes = { ...props }

export { CounselorType }
